export const envConfig = {
   apiUrl: "https://services.gallyo.com/v1",
//  apiUrl: "http://localhost:3009/v1",
 chatApiUrl: "https://chat-server.gallyo.com"
//  chatApiUrl: "http://localhost:8090"
};
